module.exports = __webpack_public_path__ + "static/polarpumpen-min-b81bd68598ce2ac99c23c434b61ab953.webp";